import { render, staticRenderFns } from "./dialogTab.vue?vue&type=template&id=75de2844&scoped=true&"
import script from "./dialogTab.vue?vue&type=script&lang=js&"
export * from "./dialogTab.vue?vue&type=script&lang=js&"
import style0 from "./dialogTab.vue?vue&type=style&index=0&id=75de2844&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75de2844",
  null
  
)

export default component.exports